/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';
import Thread, { IThread, IThreadJSON } from '../descriptors/commentsthreaddescriptor';

export interface IGetDocumentThreadsResponse extends IMessage {
	threads?: string[];
	threadsV2?: IThreadJSON[];
}

export default class GetDocumentThreadsResponse extends Message {
	public readonly threads: IThread[];

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2GetDocumentThreadsResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			threads: {
				type: 'string',
				rule: 'repeated',
				id: 1
			},
			threadsV2: {
				type: 'CommentsThreadDescriptor',
				rule: 'repeated',
				id: 2
			}
		}
	};

	public constructor( private readonly _threads?: IThread[], private readonly _threadsV2?: IThread[] ) {
		super();

		this.threads = _threadsV2?.length ? _threadsV2! : _threads!;
	}

	public toJSON(): IGetDocumentThreadsResponse {
		return {
			threads: this._threads?.map( thread => JSON.stringify( thread ) ),
			threadsV2: this._threadsV2?.map( Thread.toJSON )
		};
	}

	public static fromJSON( object: IGetDocumentThreadsResponse ): GetDocumentThreadsResponse {
		return new GetDocumentThreadsResponse(
			object.threads?.map( thread => _mapOldThread( thread ) ),
			object.threadsV2?.map( Thread.fromJSON )
		);
	}
}

function _mapOldThread( threadString: string ): IThread {
	const threadRaw: IThread = JSON.parse( threadString );

	const thread: IThread = { ...threadRaw };

	if ( threadRaw.comments ) {
		thread.comments = threadRaw.comments?.map( comment => ( {
			...comment,
			createdAt: new Date( comment.createdAt )
		} ) );
	}

	return thread;
}
